export const POPULAR_MARKETS = [
  'Los Angeles',
  'Orange',
  'San Diego',
  'Riverside',
  'San Bernardino',
  'Santa Clara',
  'San Francisco',
  'Sacramento',
  'Ventura',
  'San Mateo',
];

export const ALL_MARKETS = [
  'Alameda',
  'Alpine',
  'Amador',
  'Butte',
  'Calaveras',
  'Colusa',
  'Contra Costa',
  'Del Norte',
  'El Dorado',
  'Fresno',
  'Glenn',
  'Humboldt',
  'Imperial',
  'Inyo',
  'Kern',
  'Kings',
  'Lake',
  'Lassen',
  'Los Angeles',
  'Madera',
  'Marin',
  'Mariposa',
  'Mendocino',
  'Merced',
  'Modoc',
  'Mono',
  'Monterey',
  'Napa',
  'Nevada',
  'Orange',
  'Placer',
  'Plumas',
  'Riverside',
  'Sacramento',
  'San Benito',
  'San Bernardino',
  'San Diego',
  'San Francisco',
  'San Joaquin',
  'San Luis Obispo',
  'San Mateo',
  'Santa Barbara',
  'Santa Clara',
  'Santa Cruz',
  'Shasta',
  'Sierra',
  'Siskiyou',
  'Solano',
  'Sonoma',
  'Stanislaus',
  'Sutter',
  'Tehama',
  'Trinity',
  'Tulare',
  'Tuolumne',
  'Ventura',
  'Yolo',
  'Yuba',
];

// each market's county seat: where Today's weather is read for an advisor (a county name alone geocodes badly)
export const MARKET_SEATS: Record<string, string> = {
  'Alameda': 'Oakland',
  'Alpine': 'Markleeville',
  'Amador': 'Jackson',
  'Butte': 'Oroville',
  'Calaveras': 'San Andreas',
  'Colusa': 'Colusa',
  'Contra Costa': 'Martinez',
  'Del Norte': 'Crescent City',
  'El Dorado': 'Placerville',
  'Fresno': 'Fresno',
  'Glenn': 'Willows',
  'Humboldt': 'Eureka',
  'Imperial': 'El Centro',
  'Inyo': 'Independence',
  'Kern': 'Bakersfield',
  'Kings': 'Hanford',
  'Lake': 'Lakeport',
  'Lassen': 'Susanville',
  'Los Angeles': 'Los Angeles',
  'Madera': 'Madera',
  'Marin': 'San Rafael',
  'Mariposa': 'Mariposa',
  'Mendocino': 'Ukiah',
  'Merced': 'Merced',
  'Modoc': 'Alturas',
  'Mono': 'Bridgeport',
  'Monterey': 'Salinas',
  'Napa': 'Napa',
  'Nevada': 'Nevada City',
  'Orange': 'Santa Ana',
  'Placer': 'Auburn',
  'Plumas': 'Quincy',
  'Riverside': 'Riverside',
  'Sacramento': 'Sacramento',
  'San Benito': 'Hollister',
  'San Bernardino': 'San Bernardino',
  'San Diego': 'San Diego',
  'San Francisco': 'San Francisco',
  'San Joaquin': 'Stockton',
  'San Luis Obispo': 'San Luis Obispo',
  'San Mateo': 'Redwood City',
  'Santa Barbara': 'Santa Barbara',
  'Santa Clara': 'San Jose',
  'Santa Cruz': 'Santa Cruz',
  'Shasta': 'Redding',
  'Sierra': 'Downieville',
  'Siskiyou': 'Yreka',
  'Solano': 'Fairfield',
  'Sonoma': 'Santa Rosa',
  'Stanislaus': 'Modesto',
  'Sutter': 'Yuba City',
  'Tehama': 'Red Bluff',
  'Trinity': 'Weaverville',
  'Tulare': 'Visalia',
  'Tuolumne': 'Sonora',
  'Ventura': 'Ventura',
  'Yolo': 'Woodland',
  'Yuba': 'Marysville',
};

export const YEARS_OF_EXPERIENCE = [
  '< 1 year',
  '1–3 years',
  '3–5 years',
  '5–10 years',
  '10–15 years',
  '15–20 years',
  '20+ years',
];

export const LANGUAGES = [
  'English',
  'Spanish',
  'Mandarin',
  'Cantonese',
  'Tagalog',
  'Vietnamese',
  'Korean',
  'Japanese',
  'Hindi',
  'Farsi',
  'Arabic',
  'French',
  'Portuguese',
  'Russian',
  'German',
  'Italian',
];

export const MORE_LANGUAGES = [
  'Amharic',
  'Armenian',
  'Bengali',
  'Burmese',
  'Cambodian',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'Finnish',
  'Greek',
  'Gujarati',
  'Haitian Creole',
  'Hebrew',
  'Hmong',
  'Hungarian',
  'Indonesian',
  'Khmer',
  'Lao',
  'Malay',
  'Marathi',
  'Nepali',
  'Norwegian',
  'Pashto',
  'Persian',
  'Polish',
  'Punjabi',
  'Romanian',
  'Samoan',
  'Serbian',
  'Sinhala',
  'Slovak',
  'Somali',
  'Swahili',
  'Swedish',
  'Tamil',
  'Telugu',
  'Thai',
  'Tongan',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Welsh',
  'Yoruba',
  'Other',
];

export const REFERRAL_SOURCES = [
  'Referral',
  'LinkedIn',
  'Social media',
  'Conference',
  'Web search',
  'Other',
];
